"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveAt = moveAt;

/**
 * Moves the x-coordinate based on the shift.
 * @param x X-coordinate.
 */

/**
 * Moves the x and y coordinates based on the shift.
 * @param x X-coordinate.
 * @param y Y-coordinate.
 */
function moveAt(x, y) {
  var X = x.value - x.shift;
  var newX = X < x.min ? x.min : X > x.max ? x.max : X;

  if (y) {
    var Y = y.value - y.shift;
    var newY = Y < y.min ? y.min : Y > y.max ? y.max : Y;
    return [newX, newY];
  }

  return [newX];
}